export default __webpack_public_path__ + "static/media/CareersBody.6ecf4658.png";